import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateUserBrandSettingInput,
    DeleteUserBrandSettingInput,
    UpdateUserBrandSettingInput,
    UserBrandSetting
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class UserBrandSettingService {
    private amplifyClient = generateClient();

    constructor() {}

    async getUserBrandSettingById(id: string): Promise<UserBrandSetting> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getUserBrandSetting,
                    variables: { id }
                })
            ).data.getUserBrandSetting;
            if (data) return data as UserBrandSetting;
        } catch (error) {
            console.error('Error finding UserBrandSetting:', error);
            return null;
        }
    }

    async createUserBrandSetting(
        input: CreateUserBrandSettingInput
    ): Promise<UserBrandSetting> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createUserBrandSetting,
                    variables: {
                        input
                    }
                })
            ).data.createUserBrandSetting;
            if (date) return date as UserBrandSetting;
        } catch (error) {
            console.error('Error creating UserBrandSetting:', error);
            return null;
        }
    }

    async updateUserBrandSetting(
        input: UpdateUserBrandSettingInput
    ): Promise<UserBrandSetting> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateUserBrandSetting,
                    variables: {
                        input
                    }
                })
            ).data.updateUserBrandSetting;
            if (date) return date as UserBrandSetting;
        } catch (error) {
            console.error('Error updated UserBrandSetting:', error);
            return null;
        }
    }

    async deleteUserBrandSetting(
        input: DeleteUserBrandSettingInput
    ): Promise<UserBrandSetting> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteUserBrandSetting,
                    variables: {
                        input
                    }
                })
            ).data.deleteUserBrandSetting;
            if (date) return date as UserBrandSetting;
        } catch (error) {
            console.error('Error deleting UserBrandSetting:', error);
            return null;
        }
    }
}
